import axios from "axios";

export const getActProbList = (data) => {
  let baseURL = "";
  if (process.env.NODE_ENV === "development") {
    baseURL = process.env.VUE_APP_RIICHICITY_URL;
  }
  return axios({
    baseURL: baseURL,
    method: "post",
    url: `/client/act_prob_list`,
    data,
  });
};
